'use strict';

// this object is made available for use by the definer of config.js
export const configUtils = {
    // dark lime green
    IMS_LIME: [0x21, 0xe1, 0x36],
    IMS_RED: [0xff, 0, 0],
    IMS_GREEN: [0, 0x80, 0],
    IMS_BLUE: [0, 0, 0xff],
    IMS_ORANGE: [0xff, 0xbf, 0x00],
    IMS_ORANGE_RED: [0xff, 0x45, 0x00],
    IMS_YELLOW: [0xff, 0xff, 0],
    IMS_GOLD: [0xff, 0xd7, 0x00],
    IMS_WHITE: [0xff, 0xff, 0xff],
    IMS_DIMGREY: [0x69, 0x69, 0x69],
    IMS_BLACK: [0, 0, 0],
    IMS_CLEAR: [0, 0, 0, 0],

    // Bottom Chart Radio Stat Titles
    RADIO_STAT_RSSI_AND_NOISE: 'RSSI & Noise',
    RADIO_STAT_SNR: 'SNR',
    RADIO_STAT_RSRP: 'RSRP',
    RADIO_STAT_RSRQ: 'RSRQ',
    RADIO_STAT_SINR: 'SINR',
    RADIO_STAT_CHANNEL_UTIL: 'Channel Utilisation',
    RADIO_STAT_UTIL: 'Utilisation',
    RADIO_STAT_TOTAL_UTIL: 'Total Utilisation',
    RADIO_STAT_RATE: 'Rate',
    RADIO_STAT_TX_POWER: 'Tx Power',
    RADIO_STAT_CHANNEL: 'Channel',

    buildUrl: (
        service,
        port = undefined,
        protocol = undefined,
        hostname = undefined,
        window_location = undefined,
    ) => {
        // for easy mocking while testing
        if (window_location === undefined) {
            window_location = window.location;
        }

        if (service === undefined) {
            throw 'ERROR: buildUrl(service, port, protocol, hostname) needs at least service specified';
        }

        if (port === undefined) {
            port = window_location.port;
        }

        if (protocol === undefined) {
            protocol = window_location.protocol;
        } else if (!protocol.endsWith(':')) {
            protocol = protocol + ':';
        }

        // permit hostname to not be specified
        if (hostname === undefined) {
            hostname = window_location.hostname;
        }

        if (port === '') {
            port = window_location.port;
        }

        let url = protocol + '//' + hostname;

        if (port !== '') {
            url = url + ':' + port;
        }

        return url + service;
    },
};

export default configUtils;
